<template>
  <v-card>
    <v-card-title class="headline">{{ $t("legal.title") }}</v-card-title>
    <v-card-text>
      <p>
        {{ $t("legal.p1") }}
      </p>
      <p>{{ $t("legal.notice") }}:<br /></p>
      <p>
        {{ $t("legal.p2") }}
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
/** @define SlcLegal; weak */
</style>
